import src from "IMAGE";
export default { src, width: 370, height: 72, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAO0lEQVR42i3HoREAEBiAUVNIJnCnCLotFPzNnQ0UcymG0Q3hC8ILT/l1BAUVCfnfISi778RAg6AjwkA/azciH7pP0SoAAAAASUVORK5CYII="};
